import React, { useEffect, useRef, useState } from 'react'
import { Button,  Modal } from 'react-bootstrap';
import swal from 'sweetalert';
import algoliasearch from 'algoliasearch/lite';
import { Highlight, Hits, InfiniteHits, InstantSearch,  SearchBox, Stats, useInstantSearch } from 'react-instantsearch';
import { useRouter } from 'next/router';

import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import Head from 'next/head';


//ALGOLIA SEARCH CLIENT DETAILS
const searchClient = algoliasearch('XLDKWU66O5', 'NDcxNDEwZmM0OWM3YjQ0NTM5Mjc3Njk2YjRkNGJhOWRiNTNjN2E0MGQ2NzJjZTJkN2NhYTZiODE5ZDM3MzMzMXRhZ0ZpbHRlcnM9');






function TileReplacementModal ({isOpen, onClose, onReplace, setImgUrl, setTileReplacement, tilesUsed,setTilesUsed, newImg,setNewImg}){
   const handleTileSwap = async (url, name) =>{
    setImgUrl(url)
    let arr=[...newImg]
    arr.push(url)
    setNewImg( arr)
    setTilesUsed([...tilesUsed, name])
    onReplace()
    setTileReplacement(false)
    onClose()
  }
  function Hit ({ hit }){
    return (
      <div className='search-result-product' onClick={()=>handleTileSwap(hit.thumbnail_url, hit.name)}>
      <img src={hit.thumbnail_url}></img>
      <div><Highlight attribute="name" hit={hit} /></div> 
      </div>
    )
  }

  const queryHook = (query, search) => {
    search(query);
  };
  function NoResultsBoundary({ children, fallback }) {
    const { results } = useInstantSearch();
  
    // The `__isArtificial` flag makes sure not to display the No Results message
    // when no hits have been returned.
    if (!results.__isArtificial && results.nbHits === 0) {
      return (
        <>
          {fallback}
          <div hidden>{children}</div>
        </>
      );
    }
  
    return children;
  }
  
  function NoResults() {
    const { indexUiState } = useInstantSearch();
  
    return (
      <div>
        <p>
          No results for <q>{indexUiState.query}</q>.
        </p>
      </div>
    );
  }

  

  return(
    <Modal className='carpetlook-product-popup' show={isOpen} onHide={onClose}>
       <Modal.Header closeButton>
        <Modal.Title>Search Product</Modal.Title>
      </Modal.Header>
     <Modal.Body>
        
        
     <InstantSearch  searchClient={searchClient} indexName="oblnewver_english1_products">
     <SearchBox   queryHook={queryHook}/>
     <NoResultsBoundary fallback={<NoResults />}></NoResultsBoundary>
     <Stats
      translations={{
        rootElementText({ nbHits, processingTimeMS, nbSortedHits, areHitsSorted }) {
          return nbHits!=0 && `${nbHits.toLocaleString()} Results Found`
         
        }
      }}
     />
     {/* <Hits hitComponent={Hit} /> */}
     <InfiniteHits  hitComponent={Hit} showPrevious={false} />
    </InstantSearch>
    
      
       </Modal.Body>
      
     </Modal>
  )
}

function Carpetlook() {
    const[groutApplied, setGroutApplied]=useState(true);
    const[rows, setRows]=useState(6);
    const[cols, setCols]=useState(6);
    const[rowsInGrid, setRowsInGrid]=useState(6);
    const[colsInGrid, setColsInGrid]=useState(6);
    const [rotations, setRotations] = useState([]);
    const[tileReplacement, setTileReplacement]=useState(false);
    const[totalTiles, setTolalTiles]=useState(0);
    const[rowvalErr, setRowValErr]=useState('');
    const[colvalErr, setColValErr]=useState('');
    const [selectedTilesForReplacement, setSelectedTilesForReplacement] = useState([]);

    const[isModalOpen, setIsModalOpen]=useState(false);
    const[imgUrl, setImgUrl]= useState('');
    const[previewModalOpen, setPreviewModalOpen]= useState(false)
    const[tilesUsed, setTilesUsed]=useState([]) 
    const [replacedTiles, setReplacedTiles] = useState({});
    const router= useRouter();
    const[pdtImg, setPdtImg]= useState(router.query.img)
    const[pdtSku, setPdtSku]= useState('');
   
     const [printPreviewOpen, setPrintPreviewOpen] = useState(false);
     const printContentRef = useRef(null); 
     const[newImg, setNewImg] = useState([])
 
    useEffect(()=>{
      let totalTilesInGrid=rowsInGrid*colsInGrid;
      setTolalTiles(totalTilesInGrid);
      },[rowsInGrid, colsInGrid])
  
      useEffect(() => {
    
        const imgParam = router.query.img;
    setPdtImg(imgParam)
      console.log("00000",router.asPath)
     
      }, [router.query.img]);
   
    const rotateImage = (index) => {
         setRotations((prevRotations) => {
        const newRotations = [...prevRotations];
        newRotations[index] = (newRotations[index] || 0) + 90;
        return newRotations;
      });
    };
   

    const handleTileReplacement = (index) => {
        setSelectedTilesForReplacement((prevSelectedTiles) => {
          // If the tile is already selected, remove it from the list
          if (prevSelectedTiles.includes(index)) {
            const updatedReplacedTiles = { ...replacedTiles };
            updatedReplacedTiles[index] = newImg[newImg.length - 1]; // Using the last selected image for replacement
            setReplacedTiles(updatedReplacedTiles);
            return prevSelectedTiles.filter((selectedTile) => selectedTile !== index);
          } else {
            // If it's not selected, add it to the list
            return [...prevSelectedTiles, index];
          }
        });
      };
      
  
    const openModal = () => {
      setIsModalOpen(true);
    };
  
    const closeModal = () => {
      setIsModalOpen(false);
      
    };
   const onPreviewClose = () =>{
    setPreviewModalOpen(false)
   }
  

   

  const closePrintPreview = () => {
    setPrintPreviewOpen(false);
  };

    const replaceTile = () =>{
     selectedTilesForReplacement && selectedTilesForReplacement.map((tile)=>{
     
    }
     )
  }
    
    const handleReplaceButtonClick = async () => {
    
      if (selectedTilesForReplacement.length==0) {
        swal('Please select at least one tile image to swap');
      } else {
        openModal();
      }
    };
  

    function download(dataUrl, filename) {
      const a = document.createElement('a');
      a.href = dataUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
    
    //Fun to download the grid as an img
    const handleDownload = async () => {
      setPreviewModalOpen(true);
    
      //  to ensure that the modal content is rendered before downloading
      setTimeout(() => {
        // Get the modal node by its ID
        const modalNode = document.getElementById('preview-modal');
    
        // html2canvas is to capture the content of the modal as an image
        html2canvas(modalNode).then((canvas) => {
          // Convert the canvas to a data URL
          const dataUrl = canvas.toDataURL('image/png');
    
          // Trigger a download for the data URL
          download(dataUrl, 'grid_preview.png');
    
          // Close the modal
          setPreviewModalOpen(false);
        });
      }, 2000); 
    };
    
  
  
  const handleSubmit= async (e)=>{
       e.preventDefault()
       
       if(rows>6 ){
          setRowValErr('Rows cannot be more than 6');
          setTimeout(()=>setRowValErr(''),4000)
          
       }
       if(rows<1 ){
        setRowValErr('At least one row is needed');
        setTimeout(()=>setRowValErr(''),4000)
        
     }
     
       if(cols>6){
          setColValErr('Columns cannot be more than 6');
          setTimeout(()=>setColValErr(''),4000)
          
       }
       if(cols<1 ){
        setColValErr('At least one column is needed');
        setTimeout(()=>setColValErr(''),4000)
        
     }
       if(!rowvalErr && !colvalErr){
           setRowsInGrid(rows);
           setColsInGrid(cols);
           setRotations([]);
          }
         
  }
  
 
  const renderTileGrid = () => {
    return Array.from({ length: rowsInGrid }, (_, rowIndex) => (
      <div className='row' key={rowIndex}>
        {Array.from({ length: colsInGrid }, (_, colIndex) => {
          const tileIndex = rowIndex * colsInGrid + colIndex;
          // Check if the current tile is selected for replacement
          const isSelectedForReplacement = selectedTilesForReplacement.includes(tileIndex);
  
          return (
            <div className='col' key={colIndex}>
              <div className={`${rowIndex}${colIndex}`}>
                <img
                  src={
                    router.asPath=='/carpetlook'? 'carpet-look-default.avif':
                    (isSelectedForReplacement && newImg.length > 0)
                      ? newImg[newImg.length - 1] // Use the last selected image for replacement
                      : replacedTiles[tileIndex] || pdtImg // Use the replaced image if available, otherwise the defaut
                  }
                  alt='New tile image'
                  className={groutApplied === true ? 'withGroutBorder' : ''}
                  style={{
                    transform: `rotate(${rotations[tileIndex] || 0}deg)`,
                  }}
                  onClick={() => rotateImage(tileIndex)}
                />
                {tileReplacement && (
                  <input
                    type='checkbox'
                    onChange={() => handleTileReplacement(tileIndex)}
                    checked={isSelectedForReplacement} // Check the checkbox if the tile is selected
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    ));
  };
  

  const handlePrintButtonClick = () => {
    console.log(document.getElementsByClassName("img-section")[0].innerHTML)
    // return
    // setPreviewModalOpen(true)
    const printWindow = window.open('', '_blank');
    printWindow.document.title = 'Print Message';
    const templateContent = document.createElement('div');
    templateContent.innerHTML = document.getElementsByClassName("img-section")[0].innerHTML;
    printWindow.document.body.appendChild(templateContent);
    printWindow.print();
    printWindow.close();
    

    // Used setTimeout to ensure that the modal content is rendered before printing
    setTimeout(() => {
      // window.print(); 
      // setPrintPreviewOpen(false);
      // printModalContent();
    }, 1500); 
  };

  const printModalContent = () => {
    const content = document.getElementById('preview-modal');

    if (content) {
      const pdf = new jsPDF();
      pdf.html(content, {
        callback: () => {
          pdf.save('carpetlook.pdf');
          setPreviewModalOpen(false);
        },
      });
    }
  };
  
    return (
      <>
      <Head>
      <title>Try Different Laying patterns | Orientbell</title>
<meta name="title" content='Try Different Laying patterns | Orientbell'/>
<meta name="description" content='Orientbell Carpet look helps visualize the tiles in different laying patterns and combinations.'/>
      </Head>
      <div className='container'>
        <div className='carpet_looks'>
        <div className='carpet-left-sec'>
          <h1>Trying different laying patterns</h1>
          <span>Carpet look helps visualize the tiles in different laying patterns and combinations.</span>
          
          <div className='tile-used-section'>
            {tilesUsed.length> 0 && <h5>Tiles Used</h5>}

                  {tilesUsed.length> 0 && tilesUsed.map((item, index)=>{
                      return(
                        <ul className='tiles_added' key={index}>
                        <li >{item}</li>
                        </ul>
                      )
                  })}
                  </div>
        </div>
      <div className='dynamic-section'>
        <div className='carpet-logo'>
          <img src='CarpetlookLogo.jpg' alt='Carpet Look Logo'></img>
        </div>
      <form  className="tilecalculation" id="tilecalculation" onSubmit={handleSubmit}>
  
          <div className='grout'>
          <input type='checkbox' checked={!groutApplied}  onChange={()=>setGroutApplied(!groutApplied)}></input>
           <label>Select to remove the grout between the tiles</label>
          </div>
  
       
   <div className='img-section'>{rowsInGrid > 0 && rowsInGrid <7 &&  colsInGrid > 0 && colsInGrid<7 && renderTileGrid()}</div>
      
          <div className='replace-tile'>
          <input type='checkbox'   checked={tileReplacement} onChange={()=>setTileReplacement(!tileReplacement)}></input>
           <label>Select the tile to be replaced with other tile</label>
           {tileReplacement && <Button onClick={handleReplaceButtonClick}>Click to Replace Tile</Button>}
           <TileReplacementModal isOpen={isModalOpen} onClose={closeModal} onReplace={replaceTile}  setImgUrl={setImgUrl} setTileReplacement={setTileReplacement} tilesUsed={tilesUsed} setTilesUsed={setTilesUsed} newImg ={newImg} setNewImg={setNewImg}/>
          </div>
  
          <div className='measurement'>
            <div>
           <label>Number of rows*</label>
            <input type='number'  name='rows' value={rows} onChange={(e)=>{ setRows(e.target.value)}} required></input>
           {rowvalErr && <p className='error text-danger'>{rowvalErr}</p>}
            </div>
            <div>
            <label>Number of columns*</label>
           <input type='number' name='cols' value={cols} onChange={(e)=>{setCols(e.target.value)}} required></input>
           {colvalErr && <p className='error text-danger'>{colvalErr}</p>}
            </div>
          </div>
         <div className='measurement-button'>
         <button type='submit' onClick={handleSubmit}>Submit</button>
          </div>
          
      </form>
  
      <div className='note'>
          <h6>Note: Use of Spacer is strongly recommended for laying tiles</h6>
      </div>


      </div>
      <div className='carpet-sec-right'>
        <div className='carpet-sec-button-bx'>
          <ul>
            <li>
              <div   onClick={()=>setPreviewModalOpen(true)}>Preview</div>
            </li>
          
            <li>
       
      
   
    <a href="https://wa.me/918750733333?text=Hi, I am interested in Orientbell Tiles. I am currently browsing https://www.orientbell.com/">
      <div><img src='whatsapp.svg' alt='Icon'/> </div>
    </a>
             
            </li>
            {/* <li>
            <div onClick={handlePrintButtonClick}>Print</div>
            
            </li> */}
            <li>
              <div onClick={handleDownload}>Download</div>
            </li>
          </ul>
        </div>
      </div>
      <Modal className='carpetlook-product-popup' id='preview-modal' show={previewModalOpen} onHide={onPreviewClose}>
       <Modal.Header closeButton>
       
      </Modal.Header>
     <Modal.Body>
      {renderTileGrid() }
      </Modal.Body>
      </Modal>
     
      
        </div>
      </div>
      </>
     
    )
  }
  
  export default Carpetlook
